import * as React from "react";
import { SVGProps, memo } from "react";

const SvgYellowLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.994 21.5c-.18 0-.357-.03-.531-.087a1.17 1.17 0 0 1-.463-.288 57.783 57.783 0 0 1-2.275-2.188 24.093 24.093 0 0 1-2.275-2.662c-.7-.95-1.283-1.942-1.75-2.975-.467-1.033-.7-2.067-.7-3.1 0-2.5.804-4.492 2.412-5.975C8.021 2.742 9.883 2 12 2s3.98.742 5.587 2.225C19.197 5.708 20 7.7 20 10.2c0 1.033-.233 2.067-.7 3.1a16.364 16.364 0 0 1-1.75 2.975 24.09 24.09 0 0 1-2.275 2.663A57.804 57.804 0 0 1 13 21.125c-.133.133-.29.23-.469.288-.179.058-.358.087-.537.087Zm.008-9.75a1.68 1.68 0 0 0 1.236-.515c.341-.343.512-.755.512-1.237a1.68 1.68 0 0 0-.515-1.236 1.691 1.691 0 0 0-1.237-.512 1.68 1.68 0 0 0-1.236.515 1.69 1.69 0 0 0-.512 1.237c0 .482.172.894.515 1.236.343.341.755.512 1.237.512Z"
      fill="#E98E16"
    />
  </svg>
);

const Memo = memo(SvgYellowLocation);

export default Memo;
